<div
  *ngFor="let notification of notifications"  class="inline-notification fx-gap-15-grid fx-jc-between fx-ai-center">
  <p [innerHTML]="notification.message"></p>
  <div
    *ngIf="notification.options"  class="fx-gap-15">
    <button
      mat-flat-button
      color="red"
      *ngFor="let option of notification.options"
      (click)="runClick(option.action, notification.id)">
      {{ option.text }}
    </button>
  </div>
</div>
